export default {
  getAnswerSummary() {
    return null;
  }
};
